import React from 'react';
import { historyShape } from 'constants/propTypes';
import { FormattedMessage } from 'react-intl';
import { RedirectButton } from './BuyThalysPass.styles';

const NotLoggedInRedirectButton = ({ history }) => (
  <RedirectButton
    onClick={() =>
      history.push(`/clubeurostar/manage`, {
        prevPath: history.location.pathname,
        prevSearch: history.location.search,
        prevHash: history.location.hash
      })
    }
    id="error-page-cta"
  >
    <FormattedMessage id="errorBoundary.clubEurostar" />
  </RedirectButton>
);

NotLoggedInRedirectButton.propTypes = {
  history: historyShape
};

export default NotLoggedInRedirectButton;
